import products from '../reducers/products/products';
import user from '../reducers/user/user';
import routeDetails from '../reducers/route-details/route-details';
import companies from '../reducers/companies/companies';
import { combineReducers } from "redux";

export default combineReducers({
    products,
    user,
    routeDetails,
    companies,
});